import { AlertDto } from "../../interfaces/IAlert";
import { Dialog, DialogContent, DialogTitle, Divider, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import DialogCloseButton from "../../components/Buttons/DialogCloseButton";
import { SafeHtml } from "../../components/security/SafeHtml";
import AlertLanguageTabs from "../../components/data-display/AlertLanguageTabs";

interface AlertPreviewDialogProps {
    currentAlert: AlertDto;
    openPreviewDialog: boolean;
    setOpenPreviewDialog: (open: boolean) => void;
}

function AlertPreviewDialog({ currentAlert, openPreviewDialog, setOpenPreviewDialog }: AlertPreviewDialogProps) {
    const theme = useTheme();
    const smFullscreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [language, setLanguage] = useState(0);

    useEffect(() => {
        if (openPreviewDialog) setLanguage(0);
    }, [openPreviewDialog]);

    const shown = language === 1 && currentAlert.englishTemplate ? currentAlert.englishTemplate : currentAlert.template;

    return (
        <Dialog
            scroll="paper"
            fullWidth
            fullScreen={smFullscreen}
            open={openPreviewDialog}
        >
            <DialogTitle>
                {"Forhåndsvisning"}
                <DialogCloseButton handleClose={() => setOpenPreviewDialog(false)} />
            </DialogTitle>
            <DialogContent>
                {currentAlert.template && (
                    <>
                    {currentAlert.englishTemplate && (
                        <AlertLanguageTabs value={language} onChange={setLanguage} />
                    )}
                    {shown.editedSubject && (
                        <>
                        <Typography variant="body2" sx={{
                            mt: 2
                        }}>
                            <SafeHtml element="span" html={shown.editedSubject} />
                        </Typography>
                        <Divider />
                        </>
                    )}
                    <Typography variant="body2" sx={{
                        mt: 2
                    }}>
                        <SafeHtml element="span" html={shown.editedText} />
                    </Typography>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
}

export default AlertPreviewDialog;